<div class="comment-editor-container">
  <div class="comment-html-container">
    <dx-html-editor
      (onValueChanged)="checkCommentText($event)"
      (onKeyUp)="checkCommentText($event)"
      [(value)]="commentText"
      height="200px"
      style="margin-bottom: 16px"
    >
      <dxo-toolbar [multiline]="false">
        <dxi-item name="undo"></dxi-item>
        <dxi-item name="redo"></dxi-item>

        <dxi-item name="separator"></dxi-item>
        <dxi-item
          name="bold"
          i18n
          [options]="{ hint: customTooltips.bold }"
        ></dxi-item>
        <dxi-item
          name="italic"
          i18n
          [options]="{ hint: customTooltips.italic }"
        ></dxi-item>
        <dxi-item
          name="strike"
          i18n
          [options]="{ hint: customTooltips.strike }"
        ></dxi-item>
        <dxi-item
          name="underline"
          i18n
          [options]="{ hint: customTooltips.underline }"
        ></dxi-item>
        <dxi-item name="separator"></dxi-item>
        <dxi-item
          name="alignLeft"
          i18n
          [options]="{ hint: customTooltips.alignLeft }"
        ></dxi-item>
        <dxi-item
          name="alignCenter"
          i18n
          [options]="{ hint: customTooltips.alignCenter }"
        ></dxi-item>
        <dxi-item
          name="alignRight"
          i18n
          [options]="{ hint: customTooltips.alignRight }"
        ></dxi-item>
        <dxi-item
          name="alignJustify"
          i18n
          [options]="{ hint: customTooltips.alignJustify }"
        ></dxi-item>
        <dxi-item name="separator"></dxi-item>
        <dxi-item
          name="orderedList"
          i18n
          [options]="{ hint: customTooltips.orderedList }"
        ></dxi-item>
        <dxi-item
          name="bulletList"
          i18n
          [options]="{ hint: customTooltips.bulletList }"
        ></dxi-item>
        <dxi-item name="separator"></dxi-item>

        <dxi-item name="separator"></dxi-item>
        <dxi-item
          name="color"
          i18n
          [options]="{ hint: customTooltips.color }"
        ></dxi-item>
        <dxi-item
          name="background"
          i18n
          [options]="{ hint: customTooltips.background }"
        ></dxi-item>
        <dxi-item name="separator"></dxi-item>
        <dxi-item
          name="link"
          i18n
          [options]="{ hint: customTooltips.link }"
        ></dxi-item>
        <dxi-item
          name="image"
          i18n
          [options]="{ hint: customTooltips.image }"
        ></dxi-item>
        <dxi-item name="separator"></dxi-item>
        <dxi-item
          name="clear"
          i18n
          [options]="{ hint: customTooltips.clear }"
        ></dxi-item>
      </dxo-toolbar>
      <dxi-mention
        marker="@"
        valueExpr="emailAddress"
        displayExpr="displayName"
        [searchExpr]="['displayName', 'emailAddress']"
        [dataSource]="mentionableUsers$ | async"
        itemTemplate="mentionItem"
      ></dxi-mention>
      <div *dxTemplate="let user of 'mentionItem'" class="mention-option" [title]="user.emailAddress">
        <app-user-avatar
          [userEmail]="user.emailAddress"
          [initials]="initialsOf(user.displayName || user.emailAddress)"
          [size]="24"
        ></app-user-avatar>
        <span class="mention-suggestions__name">{{ user.displayName || user.emailAddress }}</span>
      </div>
    </dx-html-editor>

    <div class="comment-file-upload-container">
      <div
        *ngIf="!commentHasFile"
        class="comment-file-box"
        (drop)="onDrop($event)"
        (dragover)="onDragOver($event)"
        (click)="triggerFileInput()"
      >
        <p i18n="@@dropFile">
          Drag file into the area or <strong class="primary">click</strong> to
          upload
        </p>

        <input
          #commentFileInput
          type="file"
          name="upload"
          style="display: none"
          style="display: none"
          (change)="setCommsFile($event.target.files[0])"
        />

        
      </div>
      <span *ngIf="imageError" class="error-message">{{imageError}}</span>
      <div *ngIf="commentHasFile" class="comment-file-list-container">
        <b i18n="@@commentFiles">Comment Files:</b>
        <br />
        <dx-button
          [disabled]="commentFileInfo.Id == 0"
          (click)="openCommentFile(commentFileInfo)"
          stylingMode="text"
          icon="file"
          [text]="commentFileInfo.Filename"
          type="default"
        ></dx-button>
        &nbsp; &nbsp; &nbsp;
        <dx-button
          *ngIf="commentFileInfo.Id != null"
          (click)="removeCommentFile()"
          stylingMode="text"
          icon="remove"
          text
          type="warning"
        ></dx-button>
      </div>

      <div class="comment-button-container">
        <app-gpd-button
          text="Add Comment"
          i18n-text="@@addCommentCaps"
          icon="add"
          (onClick)="handleSubmit()"
          [disabled]="addCommentButtonDisabled"
        >
        </app-gpd-button>
      </div>
    </div>

    <hr class="solid" *ngIf="hasExistingComments" />

    <h3 *ngIf="hasExistingComments" i18n="@@notes">Notes</h3>

    <div *ngIf="hasExistingComments" class="comment-wrapper">
      <div *ngFor="let comment of commentList">
        <div class="comment-container">
          <div class="comment-header">
            <div class="user-container">
              <app-user-avatar
                [userEmail]="comment.createdByUser"
                [size]="32"
                class="person-avatar"
              ></app-user-avatar>
              <div class="user-info-container">
                <div class="comment-user">{{ comment.createdByUser }}</div>
                <div class="comment-date" style="font-size: 12px">
                  {{ comment.createdDate | date : "dd.MM.yyyy HH:mm" }}
                </div>
              </div>
            </div>
            <dx-button
              class="comment-delete-button"
              (onClick)="initDelete(comment.id)"
            >
              <app-svg-icon
                icon="delete"
                [size]="24"
                [strokeWidth]="1.5"
                class="icon"
                style="color: #cc2828"
              ></app-svg-icon>
            </dx-button>
          </div>
          <div class="comment-text" style="white-space: pre-wrap">
            <div [innerHTML]="comment.commentText | safeHTML"></div>
            <div
              *ngIf="
                comment.commentAttachments &&
                comment.commentAttachments.length > 0
              "
            >
              <b i18n="@@commentFiles">Comment Files:</b> <br />
              <div *ngFor="let file of comment.commentAttachments" class="comment-attachment-row">
                <dx-button
                  (click)="openCommentFile(file)"
                  stylingMode="text"
                  icon="file"
                  [text]="file.filename"
                  type="default"
                ></dx-button>
                <span #extModRefComment class="external-mod-warning" *ngIf="file.externallyModified">
                  <app-svg-icon icon="alert" [size]="18" color="var(--warning-color)"></app-svg-icon>
                  <dx-tooltip [target]="extModRefComment" showEvent="mouseenter" hideEvent="mouseleave" position="top">
                    <div *dxTemplate="let d of 'content'" i18n="@@fileModifiedExternally">Document was edited outside the system in SharePoint. Please check in SharePoint.</div>
                  </dx-tooltip>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <dx-toast
        [visible]="toastVisible"
        type="success"
        i18n-message
        message="Comment successfully added."
        position="bottom center"
        width="fit-content"
      >
      </dx-toast>

      <app-delete-popup
        [visible]="commentDeletePopupVisible"
        (onAbort)="commentDeletePopupVisible = false"
        (onConfirm)="deleteComment()"
        i18n-message
        message="Do you want to delete this comment?"
      >
      </app-delete-popup>

      <app-file-viewer #fileviewer></app-file-viewer>
    </div>
  </div>
</div>
